module.exports = __webpack_public_path__ + "img/personal25.530b0cbf.jpeg";